(() => {
  const language = document.documentElement.lang.toLowerCase().slice(0, 2);
  if (language !== 'fi' && language !== 'sv') return;
  const finnish = {
    'Denne hjemmeside bruger cookies for at sikre den bedste oplevelse på vores hjemmeside.': 'Tämä sivusto käyttää evästeitä parhaan käyttökokemuksen varmistamiseksi.',
    'Privatlivspolitik': 'Tietosuojakäytäntö',
    'Præferencer': 'Asetukset',
    'Afvis': 'Hylkää',
    'Accepter': 'Hyväksy',
    'Cookie consent actions': 'Evästevalinnat',
    'Cookieindstillinger': 'Evästeasetukset',
    'Cookie-indstillinger': 'Evästeasetukset',
    'Nødvendige': 'Välttämättömät',
    'Statistik': 'Tilastot',
    'Markedsføring': 'Markkinointi',
    'Marketing': 'Markkinointi',
    'Vis detaljer': 'Näytä tiedot',
    'Skjul detaljer': 'Piilota tiedot',
    'Gem mine præferencer': 'Tallenna valinnat',
    'Gem præferencer': 'Tallenna valinnat',
    'Accepter alle': 'Hyväksy kaikki',
    'Accepter alle cookies': 'Hyväksy kaikki evästeet',
    'Afvis alle': 'Hylkää kaikki',
    'Afvis alle cookies': 'Hylkää kaikki evästeet',
    'Country': 'Maa',
    'Language': 'Kieli',
    'Giv mig besked, når tilgængelig': 'Ilmoita, kun tuotetta on saatavilla',
    'Giv mig besked når tilgængelig': 'Ilmoita, kun tuotetta on saatavilla',
    'Notify me when available': 'Ilmoita, kun tuotetta on saatavilla',
    'Notify me when back in stock': 'Ilmoita, kun tuotetta on taas varastossa'
  };
  const swedish = {
    'Country': 'Land',
    'Language': 'Språk',
    'Giv mig besked, når tilgængelig': 'Meddela mig när produkten finns i lager',
    'Giv mig besked når tilgængelig': 'Meddela mig när produkten finns i lager',
    'Notify me when available': 'Meddela mig när produkten finns i lager',
    'Notify me when back in stock': 'Meddela mig när produkten finns i lager'
  };
  const translations = language === 'fi' ? finnish : swedish;
  const widgetSelector = [
    // Modern Consentmo accessible roots. Never match html.csm-cookie-embed.
    '[aria-label="Cookie bar"]', '[aria-label="Cookie consent actions"]',
    '[aria-label="Cookie preferences"]', '[aria-label="Cookie settings"]',
    '#csm-cookie-bar', '.csm-cookie-bar', '#csm-cookie-banner', '.csm-cookie-banner',
    '#csm-cookie-settings', '.csm-cookie-settings',
    '[class*="csm-cookie" i]:not(html):not(body)',
    'consentmo-cookie-banner', 'consentmo-cookie-settings',
    'csm-cookie-banner', 'csm-cookie-bar', 'csm-cookie-settings',
    '#isense-cc-window', '#isense-cookie-settings-dialog', '.cc-window',
    '[id*="isense" i]', '[class*="isense" i]',
    '[id*="stoq" i]', '[class*="stoq" i]',
    '[id*="restock" i]', '[class*="restock" i]',
    'restock-rocket', 'stoq-widget',
    '[id^="md-app"]', '[id^="md-modal"]', '.md-modal', '.md-form'
  ].join(',');
  const observed = new WeakSet();
  const initialized = new WeakSet();
  const discoveredShadows = new WeakSet();
  const translate = value => {
    const text = value.trim();
    return Object.prototype.hasOwnProperty.call(translations, text)
      ? value.replace(text, translations[text]) : value;
  };
  function translateText(node) {
    if (node.parentElement?.closest('script,style,textarea,code,pre')) return;
    const translated = translate(node.nodeValue);
    if (translated !== node.nodeValue) node.nodeValue = translated;
  }
  function translateAttributes(element) {
    for (const name of ['aria-label', 'placeholder']) {
      const value = element.getAttribute(name);
      if (value != null) {
        const translated = translate(value);
        if (translated !== value) element.setAttribute(name, translated);
      }
    }
  }
  function inWidget(node) {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    return !!(element?.closest(widgetSelector) || element?.getRootNode()?.host?.closest(widgetSelector));
  }
  function translateSubtree(root) {
    if (root.nodeType === Node.TEXT_NODE) { translateText(root); return; }
    if (!root.querySelectorAll) return;
    if (root.nodeType === Node.ELEMENT_NODE) translateAttributes(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) translateText(walker.currentNode);
    root.querySelectorAll('[aria-label],[placeholder]').forEach(translateAttributes);
    // Shadow discovery is confined to this newly added widget/subtree.
    const elements = root.nodeType === Node.ELEMENT_NODE ? [root] : [];
    elements.push(...root.querySelectorAll('*'));
    elements.forEach(element => {
      if (element.shadowRoot && !observed.has(element.shadowRoot)) {
        observed.add(element.shadowRoot);
        observer.observe(element.shadowRoot, {childList:true,subtree:true,characterData:true});
        translateSubtree(element.shadowRoot);
      }
    });
  }
  function discover(node) {
    if (inWidget(node)) { translateSubtree(node); return; }
    if (!node.querySelectorAll) return;
    const widgets = [];
    if (node.nodeType === Node.ELEMENT_NODE && node.matches(widgetSelector)) widgets.push(node);
    widgets.push(...node.querySelectorAll(widgetSelector));
    widgets.forEach(widget => {
      if (initialized.has(widget)) return;
      initialized.add(widget);
      observer.observe(widget, {childList:true,subtree:true,characterData:true});
      translateSubtree(widget);
    });
    discoverOpenShadowRoots(node);
  }
  function discoverOpenShadowRoots(root) {
    // Once initially, then only within newly added subtrees. The modern
    // Consentmo host can keep its accessible Cookie bar inside an open root.
    if (!root.querySelectorAll) return;
    const elements = root.nodeType === Node.ELEMENT_NODE ? [root] : [];
    elements.push(...root.querySelectorAll('*'));
    elements.forEach(element => {
      const shadow = element.shadowRoot;
      if (!shadow || discoveredShadows.has(shadow)) return;
      discoveredShadows.add(shadow);
      // Discovery watches additions only. Character updates are observed only
      // on the actual widget roots matched by widgetSelector.
      observer.observe(shadow, {childList:true,subtree:true});
      discover(shadow);
    });
  }
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') {
        if (inWidget(record.target)) translateText(record.target);
      } else {
        record.addedNodes.forEach(discover);
      }
    }
  });
  // One initial widget discovery; later work only examines added nodes or the
  // changed text node inside a known widget. Timer/carousel text is ignored.
  discover(document);
  observer.observe(document.documentElement, {childList:true,subtree:true});
  // Consent actions, saved preferences and stock/preorder handlers stay owned
  // by the existing apps. This module changes visible text and labels only.
})();
